import i18n from "@/i18n"
export const TYPE_UNDEFINED = "undefined";
export default [
    {
        mainType: "system",
        app: "System",
        color: "default",
        iconClass: "application-icon-bg-default",
        multiInstance: false
    },
    {
        mainType: "dealer_admin",
        app: "Admin",
        color: "default",
        iconClass: "application-icon-bg-default",
        multiInstance: false
    },
    {
        mainType: "help",
        app: i18n.t('_help'),
        color: "default",
        iconClass: "application-icon-bg-default",
        multiInstance: false
    },
    {
        mainType: "dealer_bit",
        app: "BIT",
        color: "purple",
        iconClass: "application-icon-bg-purple",
        multiInstance: true
    },
    {
        mainType: "dealer_bms",
        app: "BMS",
        color: "green",
        iconClass: "application-icon-bg-green",
        multiInstance: true
    },
    {
        mainType: "dealer_crm",
        app: "CRM",
        color: "blue",
        iconClass: "application-icon-bg-blue",
        multiInstance: true
    },
    {
        mainType: "agro_crm",
        app: "AgroCRM",
        color: "blue",
        iconClass: "application-icon-bg-blue",
        multiInstance: true
    },
    {
        mainType: "dealer_www",
        app: "WWW",
        color: "red",
        iconClass: "application-icon-bg-red",
        multiInstance: true
    },
    {
        mainType: "dealer_rms",
        app: "RMS",
        color: "secondary",
        iconClass: "application-icon-bg-rms",
        multiInstance: true
    },
]

export const undefinedApplicationData = {
    mainType: TYPE_UNDEFINED,
    app: "Undefined",
    color: "gray",
    iconClass: "application-icon-bg-rms",
    multiInstance: true
}